import { SearchIssues_searchIssue_docs } from '../../graphql/Issue/__generated__/SearchIssues'
import {
  IssueActions,
  ISSUES_CATEGORY_CHANGE,
  ISSUES_LOAD_SEARCH,
  ISSUES_PLATFORM_CHANGE,
  ISSUES_SEARCH_CHANGE,
  SET_ISSUES,
  ISSUES_PAGE_CHANGE,
  ISSUES_CLEAR_AND_SET_CATEGORY
} from './types'

export const issuesSearchChangeAction = (payload: string): IssueActions => ({
  type: ISSUES_SEARCH_CHANGE,
  payload
})

export const issuesCategoryChangeAction = (payload: string): IssueActions => ({
  type: ISSUES_CATEGORY_CHANGE,
  payload
})

export const issuesClearAndSetCategoryChangeAction = (payload: string): IssueActions => ({
  type: ISSUES_CLEAR_AND_SET_CATEGORY,
  payload
})

export const issuesPlatformChanged = (payload: string): IssueActions => ({
  type: ISSUES_PLATFORM_CHANGE,
  payload
})

export const issuesPageChanged = (payload: number): IssueActions => ({
  type: ISSUES_PAGE_CHANGE,
  payload
})

export const setIssues = (payload: SearchIssues_searchIssue_docs[]): IssueActions => ({
  type: SET_ISSUES,
  payload
})

export const issuesLoadSearch = (payload: any): IssueActions => ({
  type: ISSUES_LOAD_SEARCH,
  payload
})
